import script from "./UrlCode.vue?vue&type=script&setup=true&lang=js"
export * from "./UrlCode.vue?vue&type=script&setup=true&lang=js"

import "./UrlCode.vue?vue&type=style&index=0&id=e3cffc88&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3cffc88"]])

export default __exports__